import { CalculusTFunction } from '@retail/calculus/i18n';
import * as yup from 'yup';
import { dateRangeSchema } from '../../dateRangeSchema';
import { levelSelectSchema } from '../../CreateCondition';

export const roundingIdSchema = (t: CalculusTFunction) =>
  yup.object({
    priceRoundingId: yup.number().required(t('calculus.error.requiredField')),
  });

export const createRoundingConditionSchema = (t: CalculusTFunction) =>
  levelSelectSchema(t).concat(roundingIdSchema(t)).concat(dateRangeSchema(t));

export const createRoundingConditionAssortmentSchema = (t: CalculusTFunction) =>
  roundingIdSchema(t).concat(dateRangeSchema(t));

export type RoundingIdSchema = yup.InferType<ReturnType<typeof roundingIdSchema>>;

export type CreateRoundingConditionSchema = yup.InferType<
  ReturnType<typeof createRoundingConditionSchema>
>;
